/* eslint-disable no-useless-catch */
// TODO Dario please format this so no overrides are needed for try/catch
import axios from '../lib/AxApi';

export default {
    async getTicketList(data)
    {
        let val;
        try
        {
            val = await axios.post('/Player/getPlayerTickets', data);

            if (val.data !== undefined)
            {
                return val.data;
            }

            return val;
        }
        catch (e)
        {
            // TODO
            throw e;
        }
    },
    async login(params)
    {
        let val;
        try
        {
            val = await axios.post('/player/login', params);

            if (val.data !== undefined)
            {
                return val.data;
            }

            return val;
        }
        catch (e)
        {
            // TODO
            throw e;
        }
    },
    async logout(params)
    {
        let val;
        try
        {
            val = await axios.post('/player/logout', params);

            if (val.data !== undefined)
            {
                return val.data;
            }

            return val;
        }
        catch (e)
        {
            // TODO
            throw e;
        }
    },
    async getBalance(params)
    {
        let val;
        try
        {
            val = await axios.post('/player/getbalance', params);

            if (val.data !== undefined)
            {
                return val.data;
            }

            return val;
        }
        catch (e)
        {
            // TODO
            throw e;
        }
    },
};
